export default __webpack_public_path__ + "static/media/Hospital.e36f99b1.svg";